/**
 * Authorization Roles
 */

const authRoles = {
  admin: ['view:system_user'],
  operator: ['']
};

export default authRoles;
